var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2460",
    "data-name": "Rectangle 2460",
    width: 20,
    height: 18,
    transform: "translate(-0.181 0)",
    fill: "#878a99",
    stroke: "#878a99",
    strokeWidth: 0.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6664",
    "data-name": "Group 6664",
    transform: "translate(-832 -435)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2527",
    "data-name": "Rectangle 2527",
    width: 24,
    height: 24,
    transform: "translate(832 435)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6467",
    "data-name": "Group 6467",
    transform: "translate(834.204 438.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6466",
    "data-name": "Group 6466",
    transform: "translate(-0.022 -0.353)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25620",
    "data-name": "Path 25620",
    d: "M19.6,7.418c-.235.439-.519.5-.926.2Q14.309,4.432,9.945,1.24a.207.207,0,0,0-.294.009Q5.295,4.435.935,7.616C.59,7.868.289,7.857.1,7.587S-.009,7.048.332,6.8L9.373.2c.359-.262.5-.262.855,0Q14.765,3.5,19.3,6.82a2.215,2.215,0,0,1,.3.331Z",
    transform: "translate(0.018 0.288)",
    fill: "#878a99",
    stroke: "#878a99",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25621",
    "data-name": "Path 25621",
    d: "M43.312,162.034h4.074v-.23c0-1.374,0-2.748,0-4.122a2.543,2.543,0,0,1,5.077-.259c.019.266.014.534.015.8q0,1.784,0,3.568v.239h4.074v-.222q0-3.883,0-7.766c0-.378.215-.6.547-.583a.486.486,0,0,1,.453.4,1.228,1.228,0,0,1,.018.228q0,4.169,0,8.339c0,.032,0,.064,0,.1a.508.508,0,0,1-.561.537q-2.487,0-4.975,0a.512.512,0,0,1-.573-.579c0-1.6,0-3.206,0-4.809a1.528,1.528,0,1,0-3.056-.012c-.005,1.571,0,3.142,0,4.713,0,.057,0,.115,0,.172a.5.5,0,0,1-.522.514q-2.526,0-5.052,0a.5.5,0,0,1-.533-.505c0-.063,0-.127,0-.191q0-4.1,0-8.205a1.856,1.856,0,0,1,.013-.266.49.49,0,0,1,.523-.428.5.5,0,0,1,.479.458c.007.069,0,.14,0,.21q0,3.835,0,7.671Z",
    transform: "translate(-40.112 -145.345)",
    fill: "#878a99",
    stroke: "#878a99",
    strokeWidth: 0.6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.5dcdb5d76c97d8510875dd7cdb8fb7f9.svg";
export { ForwardRef as ReactComponent };